import React from 'react';

import { Screen, withScreen, createScreenRoute, Route } from '@gogame/screens';
import { Sentry } from '@gogame/components';
import screenReducer from './screenReducer';
import { SkanSchemesDataTable } from './components/SkanSchemesDataTable';
import { skanSchemesLink, skanSchemeSearchParams } from './navigation';
import { skanSchemeDetailsLink } from './navigation';
import { SkanSchemeDetailsRouteElement } from './components/SkanSchemeDetails';

const id = 1076;
const permission = 86;

const SkanSchemes = withScreen({
  name: 'skan-schemes',
  searchParams: skanSchemeSearchParams,
  reducer: screenReducer,
})(() => {
  return (
    <React.Fragment>
      <Screen.Toolbar />
      <Screen.Body>
        <SkanSchemesDataTable />
        <Sentry.Routes>
          <Route
            path={skanSchemeDetailsLink.path}
            element={<SkanSchemeDetailsRouteElement />}
          />
        </Sentry.Routes>
      </Screen.Body>
    </React.Fragment>
  );
});

export default createScreenRoute({
  title: 'SKAN Schemes',
  link: skanSchemesLink,
  id: id,
  permission: permission,
  screen: <SkanSchemes />,
});
